import {KEYS} from '../constants/keysStorage'
import * as axioshttp from './axios'

export function get(
  url: string, 
  params = {}, 
  token:string|null = null, 
  headersExtras = {}, 
  options = {}
) {
  return axioshttp.request('GET', url, {}, getHeaders(headersExtras, options, token), params)
}

export function post(
  url: string, 
  body = {}, 
  params = {}, 
  token:string|null = null, 
  headersExtras = {}, 
  options = {}
) {
  return axioshttp.request('POST', url, body, getHeaders(headersExtras, options, token), params)
}

export function put(
  url: string, 
  body = {}, 
  params = {}, 
  token:string|null = null, 
  headersExtras = {}, 
  options = {}
) {
  return axioshttp.request('PUT', url, body, getHeaders(headersExtras, options, token), params)
}

export function _delete(
  url: string, 
  body = {}, 
  params = {}, 
  token:string|null = null, 
  headersExtras = {}, 
  options = {}
) {
  return axioshttp.request('DELETE', url, body, getHeaders(headersExtras, options, token), params)
}

export function getHeaders(headersExtras = {}, options = {}, otherToken:string|null = null) {
  let token = otherToken ? localStorage.getItem(otherToken) : localStorage.getItem(KEYS.TOKEN)
  let headers = {
    Authorization: `${token ? `Bearer ${token}` : ""}`,
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': '*',
    ...headersExtras,
  }

  return headers;
}
